import React from 'react'

function Footer() {
  return (
    <h1 className='text-center Title mt-5'>
            &copy; designed & built by Amine Abaidi 2023
    </h1>
  )
}

export default Footer